import { TemplateListError, TemplateListErrorText } from '../types';

function createTemplateError(
  error: TemplateListErrorText
): TemplateListError {
  return { templateErrorType: error, helperText: error + '_helper_text' };
}

export const NOT_FOUND_ERROR = createTemplateError(
  TemplateListErrorText.notFound
);

export const NO_TEMPLATES_ERROR = createTemplateError(
  TemplateListErrorText.noTemplates
);

export const NO_FILTERED_TEMPLATES_ERROR: TemplateListError = {
  templateErrorType: TemplateListErrorText.noFilteredTemplates,
  helperText: 'list_search_empty_subtitle',
};
